import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../../../shared/Fetch";


const DiceCompanySettingTable = (props: any) => {
  // const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>; loading: boolean });
  const [tableData, setTableData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const dt = useRef<any>(null);

  const loadTableData = async () => {
    setLoading(true);

    const response = await Fetch("Dice_Setting/getDiceCompanySetting", "GET", null, null, props.toast);

    if (response) {
      const data = await response.json();
      setTableData(data); 
    }

    setLoading(false);
  };

  useEffect(() => {
    loadTableData();
  }, [props.reload]);
  return (
    <>
      <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }} size="small" ref={dt} value={tableData} emptyMessage="No Data found." loading={loading} showGridlines stripedRows responsiveLayout="scroll">
        <Column field="company_Name" header="Company Name" />
        <Column field="no_Of_Views" header="No of View Allowed" />
      </DataTable>
    </>
  );
};

export default DiceCompanySettingTable;
